// @flow

import * as React from 'react'
import TaskListItem from './task-list-item'
import {connect} from 'react-redux'
import ClassNames from 'classnames'
import {updateTask, deleteTask} from '../actions/tasks'
import type {Task, Dispatch} from '../types'

type Props = {
  tasks: $ReadOnlyArray<Task>,
  babyToken: string,
  hideChecks: boolean,
  dispatch: Dispatch,
}

class TaskList extends React.Component<Props> {
  static defaultProps = {
    hideChecks: false,
  }

  handleTaskUpdate: Task => void
  handleTaskDelete: number => void

  constructor(props: Props) {
    super(props)
    this.handleTaskUpdate = this.handleTaskUpdate.bind(this)
    this.handleTaskDelete = this.handleTaskDelete.bind(this)
  }

  handleTaskUpdate(task: Task) {
    const {dispatch, babyToken} = this.props
    dispatch(updateTask(babyToken, task.id, task))
  }

  handleTaskDelete(taskId: number) {
    const {dispatch, babyToken} = this.props
    dispatch(deleteTask(babyToken, taskId))
  }

  render() {
    const {tasks, hideChecks} = this.props
    const className = ClassNames('task-list', {'has-hidden-checks': hideChecks})
    return (
      <div className={className}>
        {tasks.map(t => (
          <TaskListItem
            hideChecks={true}
            onUpdate={this.handleTaskUpdate}
            onDelete={this.handleTaskDelete}
            key={`task-${t.id}`}
            task={t}
          />
        ))}
      </div>
    )
  }
}

export default connect()(TaskList)
